module.exports = __webpack_public_path__ + "img/install_theme_icon_6.958ac916.png";